<template lang="html">
  <div v-if="show"  class="i-empty">
    <div @click="handleClick" class="i-empty-content">
      <div class="i-empty-icon">
        <img src="../assets/i-empty.png" alt="">
      </div>
      <div class="i-empty-text">
        暂无数据，点我重试
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'i-empty',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (!this.show) return;
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.i-empty{
  height: 60%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .i-empty-content {
    text-align: center;
    margin: 20px 0;
    .i-empty-icon {
      img {
        vertical-align: middle;
        width: 100px;
      }
    }
    .i-empty-text {
      font-size: 12px;
      padding: 10px;
      color: #666;
    }
  }
}
</style>
